import { ReactElement } from 'react'
import { NumberFormatProps } from 'react-number-format'
import { InputAdornment, TextField } from '@mui/material'
import { NumberInput } from '@ui/forms'

interface Props {
  label: string
  /** Length in m */
  value?: number
  /** Called with lengths greater than zero only */
  onChange: (value: number) => void
  disabled?: boolean
  'data-cy'?: string
}

/** Rounded so that float noise from the geometry does not show up while typing */
const toDisplayValue = (value?: number) =>
  value === undefined ? '' : String(Math.round(value * 1e6) / 1e6)

/**
 * Edge length of an area load rectangle. Not a form field: the value is derived from the corner
 * points, and a change rebuilds them.
 */
const AreaLoadLengthField = ({
  label,
  value,
  onChange,
  disabled,
  'data-cy': dataCy,
}: Props): ReactElement => (
  <TextField
    label={label}
    value={toDisplayValue(value)}
    size="small"
    fullWidth
    disabled={disabled}
    data-cy={dataCy}
    slotProps={{
      input: {
        inputComponent: NumberInput as never,
        endAdornment: <InputAdornment position="end">m</InputAdornment>,
        inputProps: {
          disableDecimalScale: true,
          isNumericString: true,
          allowNegative: false,
          onValueChange: (values, sourceInfo) => {
            if (sourceInfo.source !== 'event') return
            if (values.floatValue !== undefined && values.floatValue > 0) {
              onChange(values.floatValue)
            }
          },
        } as NumberFormatProps,
      },
    }}
  />
)

export default AreaLoadLengthField
